@let resultContent = getResultContent();
<img
	class="image"
	[src]="getIconUrl()"
/>
<div class="result-block">
	<p class="result-block__title">{{ resultContent.titleText }}</p>
	<p class="result-block__message">{{ resultMessage }}</p>
</div>
